import { useContext } from 'react';

import { AppEndpoints } from '../../../types/app';
import { AppContext } from '../store';
import { AppContextDispatcher, AppContextState } from '../types';

/**
 * Hook to get the app context
 * @returns {{ state: AppContextState, dispatch: AppContextDispatcher, endpoints: AppEndpoints }}
 */
export const useAppContext = (): {
  state: AppContextState;
  dispatch: AppContextDispatcher;
  endpoints: AppEndpoints;
} => {
  const [state, dispatch, endpoints] = useContext(AppContext);

  return {
    state,
    dispatch,
    endpoints: endpoints!,
  };
};
